var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"font-weight-medium text-h5 text-uppercase",attrs:{"min-width":"0","color":"white","to":_vm.path,"exact":""}},[_c('span',{staticStyle:{"color":"black"}},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }